import React from 'react';
import { Datagrid, DeleteButton, EditButton, List, TextField, DateField } from 'react-admin';
import StatusField from '../../../commonComponents/StatusField';
import CustomListActions from '../../../commonComponents/ListActions/CustomListActions';

const SurveysList = (props) => (
  <List
    title="Surveys"
    bulkActionButtons={false}
    actions={<CustomListActions />}
    exporter={false}
    sort={{ field: 'id', order: 'DESC' }}
    {...props}
  >
    <Datagrid rowClick="edit">
      <TextField label="ID" source="id" />
      <TextField label="Name" source="name" sortable={false} />
      <StatusField label="Status" source="status" sortable={false} />
      <DateField label="Publish date" source="published_at" />
      <EditButton />
      <DeleteButton undoable={false} />
    </Datagrid>
  </List>
);

export default SurveysList;
